import React, {Component} from 'react';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import TandCComponent from '../TandCComponent/TandCComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';
import SocialLoginDisplayComponent from '../SocialLoginDisplayComponent/SocialLoginDisplayComponent';

class SocialLoginPageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            errorTitle: ''
        };
    }

    clearAlert = () => {
        this.setState({error: '', errorTitle: ''});
    };

    handleError = (error) => {
        this.setState({error});
    };

    render() {
        const {
            authAccountType,
            lingua,
            multiUserEnabled,
            performBulkPageUpdate
        } = this.props;
        const {error, errorTitle} = this.state;
        let cardContent = (
            <SocialLoginDisplayComponent
                handleError={this.handleError}
                {...this.props}
            />
        );

        return (
            <div className="SocialLogInPageDisplayComponent">
                <HeaderSectionComponent
                    title={lingua.read('lex.header.login')}
                />
                <CalloutCardComponent
                    content={cardContent}
                    error={error}
                    errorTitle={errorTitle}
                    authAccountType={authAccountType}
                    performBulkPageUpdate={performBulkPageUpdate}
                    clearAlert={this.clearAlert}
                />
                <TandCComponent
                    lingua={lingua}
                    multiUserEnabled={multiUserEnabled}
                />
            </div>
        );
    }
}

export default SocialLoginPageComponent;
